import type UserStore from 'src/state/user';
import type { Dispensaries } from 'src/gql/graphql';
import type {
  CommerceState,
  Dispensary,
  StoreOpenState,
  AccountMenu,
  LoyaltyState,
  User,
} from 'src/concierge/contract';
import { InterfaceVariants } from 'src/constants/interface-variants';
import { mapDispensaryToRemote } from 'src/theme/provider/commerce-components/bridge/bridge-map-dispensary';

export function isValidMenuVariant(v: InterfaceVariants): v is CommerceState['menuVariant'] & InterfaceVariants {
  return v === InterfaceVariants.embedded || v === InterfaceVariants.kiosk || v === InterfaceVariants.storeFront;
}

export function mapDispensary(dispensary: Dispensaries, openState?: StoreOpenState): Dispensary {
  const base = mapDispensaryToRemote(dispensary);
  if (!base) {
    throw new Error('Concierge: mapDispensary expected a non-null dispensary');
  }
  return { ...base, openState };
}

export function mapUser(user: UserStore, accountMenu: AccountMenu | undefined, loyalty: LoyaltyState): User {
  return {
    accountMenu,
    birthday: user.birthday,
    email: user.email ?? '',
    firstName: user.firstName,
    isLoggedIn: user.isLoggedIn,
    lastName: user.lastName,
    loyalty,
    // Forward no token when expired — the gate 401s a stale token with no guest
    // fallback; degrading to guest matches the rest of the platform.
    token: user.expiredToken ? undefined : user.token ?? undefined,
  };
}
